<div class="out" #segment (mousemove)="onMouseMove($event)" (pointerup)="onMouseUp($event)">
  <div class="title">
    Editor Tool
  </div>
  <div class="top">

    <div class="left">
      <div class="">
        Use the timeline below to select video segments for each step. <br />Click to set the video time. Drag the handles to set the scene start and end. Save it.
      </div>
    </div>
    <div class="right">
      <input class="in" type="text" name="" [(ngModel)]="name" value="">
      <div class="bsave" (click)="save()">
        <div>
          Save
        </div>
      </div>
    </div>
  </div>


  <div class="container" #container>
    <div class="vlines">
      <div *ngIf="scene_s>0" class="num" [style.left.px]="left_h">
        {{scene_s | number:'1.0-0'}}
      </div>
      <div class="num" [style.right.px]="right_t">
        {{scene_e | number:'1.0-0'}}
      </div>
    </div>
    <div class="vlines">
      <div *ngFor="let line of lines;let i = index" class="vline" [style.left.px]="line">

      </div>
    </div>


    <div class="movie" [style.width.px]="box_width" (click)="selSceneByPoin($event)">
      <div class="scene" [style.background]="bcolor" [style.border]="border" [style.left.px]="left_b" [style.width.px]="width_b" (click)="onClick($event)">

        <div class="scene_p" [style.background]="scene_pc" [style.width.px]="scene_pw">
        </div>
      </div>
      <div class="s_h" [style.left.px]="left_h" [style.background]="color" (pointerdown)="onLhDown($event)">

      </div>
      <div class="s_h" [style.left.px]="right_h" [style.background]="color" (pointerdown)="onRhDown($event)">

      </div>
    </div>
  </div>
</div>
